export default "__VITE_ASSET__745567d6__"